<template>
  <el-form
      ref="form"
      :model="form">
    <el-form-item
        v-if="bidInput"
        label="默认竞价"
        prop="bid"
        :label-width="bidLabelWidth">
      <gj-input
          v-model="form.bid"
          width="200px">
        <template #prepend>{{adStore.SP.currencySymbol}}</template>
      </gj-input>
    </el-form-item>
    <el-row
        type="flex"
        class="gj-picker">
      <div class="gj-picker__editor" :style="{width}">
        <el-tabs :value="'first'">
<!--          分类-->
          <el-tab-pane
              name="first">
            <template #label>
              分类
              <gj-help>各类商品是按相似性划分在一起的商品，如女士跑鞋。</gj-help>
            </template>
            <div class="gj-picker__editor--body" style="margin-top: 1px;">
              <gj-table
                  :index="false"
                  :show-pagination="false"
                  :show-overflow="false"
                  :adapt-height="false"
                  :loading="suggestCategoriesLoading"
                  :height="403"
                  :data="recommendCategoryData"
                  :columns="columns0"
                  class="suggest-table">
                <template v-slot:header:op>
                  <gj-button
                      type="text"
                      @click="addAllCategory()"
                  >定位全部</gj-button>
                </template>
                <template v-slot:recommendCategory="{ row }">
                  <div style="line-height: 18px;">
                    <div>{{row.path | defaultShow}}</div>
                    <div><span style="font-weight: bold;">分类：</span>{{row.name | defaultShow}}</div>
                  </div>
                </template>
                <template v-slot:op="{ index, row }">
                  <gj-button
                      size="mini"
                      type="ghost"
                      :disabled="row.btnDisabled"
                      style="padding: 5px 15px;"
                      @click="addCategory(index, row)"
                  >定位</gj-button>
                  <!--:disabled="row.btnDisabled"-->
                  <gj-button
                      type="text"
                      @click="refineCategory(index, row)"
                  >细化</gj-button>
                </template>
              </gj-table>
            </div>
          </el-tab-pane>
<!--          商品-->
          <el-tab-pane name="second">
            <template #label>
              商品
              <gj-help>定位到与您广告中宣传的商品类似的各个商品。</gj-help>
            </template>
            <el-tabs :value="'first'">
<!--              建议ASIN-商品-->
              <el-tab-pane
                  name="first">
                <template #label>
                  建议ASIN-商品
<!--                  <gj-help>根据您广告中宣传的商品建议的商品。</gj-help>-->
                </template>
                <gj-table
                    :index="false"
                    :show-pagination="false"
                    :show-overflow="false"
                    :adapt-height="false"
                    :loading="suggestProductLoading"
                    :height="365"
                    :data="recommendAsinData"
                    :columns="recommendAsinColumns">
                  <template v-slot:header:op>
                    <gj-button
                        type="text"
                        @click="addAllRecommendAsin"
                    >定位全部</gj-button>
                  </template>
                  <template v-slot:asin="{row}">
                    <gj-link v-if="row.amazonAsinUrl" :href="row.amazonAsinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
                    <template v-else>{{row.asin | defaultShow}}</template>
                  </template>
                  <template v-slot:op="{ index, row }">
                    <gj-button
                        type="text"
                        :disabled="row.btnDisabled"
                        @click="addRecommendAsin(index, row)"
                    >定位</gj-button>
                  </template>
                </gj-table>
              </el-tab-pane>
<!--              建议ASIN-主题-->
              <el-tab-pane
                  name="second">
                <template #label>
                  建议ASIN-主题
<!--                  <gj-help>根据您广告中宣传的商品建议的商品。</gj-help>-->
                </template>
                <gj-table
                    :index="false"
                    :show-pagination="false"
                    :show-overflow="false"
                    :adapt-height="false"
                    :loading="suggestProductLoading"
                    :height="365"
                    :data="themeData"
                    :columns="themeColumns">
                  <template v-slot:header:theme>
                    <gj-select
                        v-model="theme"
                        :options="themeOption"
                        width="180px"
                        :clearable="false"
                        :filterable="false"
                        @change="getThemeProduct()"
                        >
                    </gj-select>
                    <gj-help style="margin-left: 4px;">
                      1、高转化定位：这些产品在过去 30 天内为您的广告商品产生了转化，此销售额降序排列。<br>
                      2、经常一起看的相似产品：客户在购物过程中经常和您的广告商品一起查看和点击的商品。<br>
                      3、补充产品：经常作为补充品一起购买的物品，例如，如果您要宣传网球拍，此主题下可能会推荐网球产品。<br>
                      4、评分低评论少的相似产品：包含评分低于 3 星和/或评论少于 5 条的商品。<br>
                      5、您的读者阅读的其他书籍：适用图书卖家，客户在购物过程中经常和您的广告商品一起查看和点击的商品。
                    </gj-help>
                  </template>
                  <template v-slot:asin="{row}">
                    <gj-link :href="row.amazonAsinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
                  </template>
                  <template v-slot:header:op>
                    <gj-button
                        type="text"
                        @click="addAllthemeAsin"
                    >定位全部</gj-button>
                  </template>
                  <template v-slot:op="{ index, row }">
                    <gj-button
                        type="text"
                        :disabled="row.btnDisabled"
                        @click="addRecommendAsin(index, row)"
                    >定位</gj-button>
                  </template>
                </gj-table>
              </el-tab-pane>
<!--              输入ASIN-->
              <el-tab-pane label="输入ASIN" name="three">
                  <AdBatchInput :items="form.items" v-model="inputText" :beforeFn="beforeFn" :afterFn="afterFn"></AdBatchInput>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="gj-picker__table" :style="{width}">
        <div class="gj-picker__table--title">
          已添加 {{form.items.length}} 个{{title}}<span class="gj-picker__table--tip">（最多可添加1000个，会过滤重复的{{title}}）</span>
        </div>

        <gj-table
            :index="false"
            :show-pagination="false"
            :show-overflow="false"
            :adapt-height="false"
            :height="403"
            :data="form.items"
            :columns="columns"
            >

          <template v-slot:header:op>
            <gj-button
                type="text"
                @click="deleteAllItem()"
            >全部移除</gj-button>
          </template>

          <template v-slot:category="{ row }">
            <div v-if="row.type === 'path' || row.type === 'refine'" style="line-height: 18px;">
              <div>{{row.path | defaultShow}}</div>
              <div v-gutter="8">
                <strong>分类：</strong>{{row.name | defaultShow}}
                <strong v-if="row.brandId">品牌：</strong>{{row.brandName}}
              </div>
              <div v-gutter="8">
                <span v-if="isMeaningful(row.lowPrice) && isMeaningful(row.maxPrice) "><strong>商品价格：</strong>{{row.lowPrice | defaultShow}} - {{row.maxPrice | defaultShow}} </span>
                <span v-if="isMeaningful(row.lowPrice) && !isMeaningful(row.maxPrice) "><strong>商品价格：</strong>不低于{{row.lowPrice | defaultShow}} </span>
                <span v-if="!isMeaningful(row.lowPrice) && isMeaningful(row.maxPrice) "><strong>商品价格：</strong>不高于{{row.maxPrice | defaultShow}} </span>
                <span v-if="isMeaningful(row.marks)"><strong>评分：</strong>{{starTo(row.marks)}} 星</span>
                <span v-if="isMeaningful(row.prime) && row.prime !== 'NO'"><strong>配送：</strong>{{primeTo(row.prime)}} </span>
              </div>
            </div>
            <template v-if="row.type === 'asin'">
              <div><strong>商品：</strong>{{row.asin | defaultShow}}</div>
            </template>
          </template>

          <template v-slot:recommendedBid="{ row }">
            <gj-button type="text" @click="applicationFn('item', row)">{{ row.recommendedBid  | defaultShow(adStore.SP.currencySymbol) }}</gj-button>
          </template>

          <template v-slot:header:application>
            <gj-button type="text" @click="applicationFn('all')">全部应用</gj-button>
          </template>

          <template v-slot:application="{ row }">
            {{ row.rangeStart ? adStore.SP.currencySymbol +  row.rangeStart : ""}}
               - 
            {{ row.rangeEnd ? adStore.SP.currencySymbol +  row.rangeEnd : ""}}
          </template>

          <template v-slot:bid="{ index }">
            <el-form-item
                :prop="`items.${index}.bid`"
                :rules="[
                  { required: true, message: '请输入竞价', trigger: ['blur', 'change'] },
                  $gjReRule(RE.num(2), '请输入最多两位小数'),
                  $gjMinRule(0.02, '应大于等于0.02'),
                ]"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[index].bid"
                  v-number.price
                  width="115px"
                  size="mini">
                <template #prepend>{{adStore.SP.currencySymbol}}</template>
              </gj-input>
            </el-form-item>
          </template>

          <template v-slot:op="{ index, row }">
            <gj-button
                type="text"
                @click="deleteItem(index, row)"
            >移除</gj-button>
          </template>
        </gj-table>

      </div>
    </el-row>
    <div class="gj-picker-solid"></div>
  </el-form>
</template>

<script>
  import {formMixin, formRuleMixin, isMeaningfulMixin} from "@/minxins";
  import {isMeaningful, unique} from "@/utils/common";
  import AppProductTargetRefineModal from "./modal/product-target-refine-modal";
  import {adStore} from "@/views/modules/ad/common/store";
  import AdBatchInput from '@/views/modules/ad/common/components/ad-batch-input.vue'
  import {
    getAdProductTargetBrand,
    categoryRecommendation,
    productRecommendation,
      SP
  } from "@/api/ad";

  export default {
    name: "app-product-target-picker",
    mixins: [isMeaningfulMixin, formMixin, formRuleMixin],
    components: { AdBatchInput },
    props: {
      marketId: {
        required: true
      },
      title: {
        required: true,
      },
      bidInput: {
        type: Boolean,
        default: false,
      },
      bidLabelWidth: {
        type: String,
        default: '150px'
      },
      width: {
        type: String,
        default: '500px',
      },
      adProduct$: {
        required: true
      },
      formBase: {
        default: () => ({})
      },
      // 是否显示建议竞价
      showSuggestedBidding: {
        type: Boolean,
        default: false
      }
    },
    created() {
      if (!this.showSuggestedBidding) {
        this.columns.splice(1, 2)
      }
    },
    data() {
      return {
        keyword: null,
        inputText: null,
        //分类Data
        recommendCategoryData: [],
        //建议ASIN-商品Data
        recommendAsinData: [],
        //建议ASIN-主题Data
        themeData: [],
        //分类column
        columns0: [
          {id: 'recommendCategory', header: '建议分类',field: 'slot:recommendCategory', minWidth: '180px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', width: '120'},
        ],
        //已添加商品column
        columns: [
          {id: 'category', header: '分类和商品',field: 'slot:category', minWidth: '180px'},
          {id: 'recommendedBid', header: '建议竞价', field: 'slot:recommendedBid', minWidth: '70px', align: 'right'},
          {id: 'application', header: 'slot:application', field: 'slot:application', minWidth: '120px'},
          {id: 'bid', header: '竞价', field: 'slot:bid', width: '135px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', width: '80'},
        ],
        //建议ASIN-商品column
        recommendAsinColumns: [
          {id: 'smallImageUrl', header: '图片',field: 'picture:smallImageUrl', width: '60px'},
          {id: 'asin', header: 'ASIN', field: 'slot:asin', minWidth: '130px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', width: '80'},
        ],
        //建议ASIN-主题column
        themeColumns: [
          {id: 'smallImageUrl', header: '图片',field: 'picture:smallImageUrl', width: '60px'},
          {id: 'asin', header: 'ASIN', field: 'slot:asin', minWidth: '100px'},
          {id: 'theme', header: 'slot:theme', field: 'theme', minWidth: '200px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', width: '80'},
        ],

        //选中的主题
        theme:0,
        //主题选项
        themeOption:[
          {id:0,text:'高转化定位'},
          {id:1,text:'经常一起看的相似产品'},
          {id:2,text:'补充产品'},
          {id:3,text:'评分低评论少的相似产品'},
          {id:4,text:'您的读者阅读的其他书籍'},
        ],

        errorKeyword: false,
        keywordStyle: {height: '292px'},
        adStore: adStore,
        suggestCategoriesLoading: false,
        suggestProductLoading: false,

        asinList:null
      }
    },
    watch: {
      inputText(val) {
        this.errorKeyword = !/^[^!#%<>@*$]*$/.test(val);
      },
      adProduct$: {
        handler(adProduct$) {
          if (isMeaningful(adProduct$)) {
            this.suggestCategoriesLoading = true;
            this.suggestProductLoading = true;
              adProduct$
                .then((data) => {
                  if(typeof data === 'string'){
                    return Promise.resolve(data)
                  }else {
                    return Promise.resolve((data.records || []).map(e => e.asin));
                  }
                })
                .then((asinList) => {
                  this.asinList = asinList;
                  this.getSuggestCategories();
                  this.getSuggestProduct();
                  this.getThemeProduct()
                })
            }
        },
        immediate: true
      },
      formBase:{
        handler(val) {
          this.recommendCategoryData = [];
          //建议ASIN-商品Data
          this.recommendAsinData = [];
          //建议ASIN-主题Data
          this.themeData = [];
        },
        deep:true
      }
    },
    methods: {
      // （全部）应用商品投放
      applicationFn(type, row) {
        const opt = {
          all:()=> {
            this.form.items.forEach(item => {
              item.bid = item.recommendedBid
            })
          },
          item: () => {
            row.bid = row.recommendedBid
          },
        }
        opt[type]()
      },
      //获取分类Data
      getSuggestCategories() {
        this.suggestCategoriesLoading = true;
        let params = {
          marketId: this.marketId
        }
        if(this.showSuggestedBidding){
          params.groupId = this.formBase.groupId
        }else {
          params.asinList = this.asinList
        }
        categoryRecommendation(params)
          .then((data) => {
            this.recommendCategoryData = (data || []).map(item => ({
              ...item,
              categoryId: item.id,
              categoryName: item.name
            }));
            this.refreshBtnDisable();
          })
          .complete(() => this.suggestCategoriesLoading = false);
      },
      //建议ASIN-商品Data
      getSuggestProduct() {
        this.suggestProductLoading = true;
        let params = {
          marketId: this.marketId,
          isTheme:false
        }
        if(this.showSuggestedBidding){
          params.groupId = this.formBase.groupId
        }else {
          params.asinList = this.asinList
        }
        productRecommendation(params)
          .then(({recommendedProducts}) => {
            this.recommendAsinData = (recommendedProducts || []).map(e => ({
              ...e,
              asin: e.recommendedTargetAsin
            }));
            this.refreshBtnDisable();
          })
          .complete(() => this.suggestProductLoading = false);
      },
      //建议ASIN-主题Data
      getThemeProduct() {
        this.suggestProductLoading = true;
        let params = {
          marketId: this.marketId,
          isTheme:true,
          theme:this.theme
        }
        if(this.showSuggestedBidding){
          params.groupId = this.formBase.groupId
        }else {
          params.asinList = this.asinList
        }
        productRecommendation(params)
            .then(({recommendedProducts}) => {
              this.themeData = (recommendedProducts || []).map(e => ({
                ...e,
                theme: e.themes.map(m => this.themeOption.find(n => n.id === m).text).join('，'),
                asin: e.recommendedTargetAsin
              }));
              this.refreshBtnDisable();
            })
            .complete(() => this.suggestProductLoading = false);
      },
      //商品Data 全部定位
      addAllRecommendAsin() {
        this.addAllItem(this.recommendAsinData, 'asin', 'asin');
      },
      //主题Data 全部定位
      addAllthemeAsin() {
        this.addAllItem(this.themeData, 'asin', 'asin');
      },
      //商品 单个定位
      addRecommendAsin(index, row) {
        this.addAllItem([row], 'asin', 'asin');
      },
      //分类 全部定位
      addAllCategory() {
        this.addAllItem(this.recommendCategoryData, 'path', 'path');
      },
      //分类 单个定位
      addCategory(index, row) {
        this.addAllItem([row], 'path', 'path');
      },
      //分类 细化
      refineCategory(index, row) {
        const modal = this.$gjCreate(AppProductTargetRefineModal, {
          mountTo: adStore.SP.rootMountEl,
          props: {
            brandOption$: getAdProductTargetBrand({
              marketId: this.marketId,
              categoryId: row.id
            }),
            category: row.name,
            item: row,
            currencySymbol: adStore.SP.currencySymbol
          },
          on: {
            refine: () => {
              const item = {...row};
              Object.assign(item, modal.form);
              this.addAllItem([item], 'refine', 'path');
            }
          }
        });
      },
      // 刷新按钮禁用状态？
      refreshBtnDisable() {
        this._refreshBtnDisable(this.recommendCategoryData, 'path', 'path');
        this._refreshBtnDisable(this.recommendAsinData, 'asin', 'asin');
        this._refreshBtnDisable(this.themeData, 'asin', 'asin');
      },
      _refreshBtnDisable(items, type, key) {
        items.forEach(e1 => {
          if (this.form.items.some(e2 => `${type}_${e1[key]}` === e2.identity)) {
            this.$set(e1, 'btnDisabled', true);
          } else {
            this.$set(e1, 'btnDisabled', false);
          }
        });
      },
      addAllItem(items, type, key) {
        //处理需要添加的数组
        let itemsArr = items.map(e => ({
          identity: `${type}_${e[key]}`,
          ...e,
          bid: this.form.bid,
          type,
        }))
        //遍历生成右边已选择的列表
        if(type === 'refine'){
          //若是细化，则修改‘identity’，使其唯一
          itemsArr[0].identity = itemsArr[0].identity
              + (itemsArr[0].brandId||'null')
              + itemsArr[0].marks[0] + itemsArr[0].marks[1]
              + (itemsArr[0].lowPrice||'null') + (itemsArr[0].maxPrice||'null')
              + itemsArr[0].prime;
        }
        //点定位的数据添加至右边table
        this.form.items = unique([].concat(this.form.items).concat(itemsArr), 'identity');

        // 若需要获取建议竞价（只有商品广告-商品投放-新增商品投放）
        if(this.showSuggestedBidding){
          // 获取建议竞价接口入参
          let params = {
              marketId:this.marketId,
              groupId: this.formBase.groupId || null,//广告组id
              targetingParam:[]
            };
          itemsArr.forEach(r => {
            let m;
            //按分类
            if(key === 'path'){
              //按分类-定位
              if(type === 'path'){
                params.targetingParam.push({
                  index:r.identity,
                  categoryId:r.categoryId,
                  categoryName:r.categoryName
                })
              }
              //按分类-细化
              else {
                params.targetingParam.push({
                  index: r.identity,
                  categoryId: r.categoryId,
                  categoryName: r.categoryName,
                  brandId: r.brandId,
                  brandName: r.brandName,
                  minPrice: r.lowPrice,
                  maxPrice: r.maxPrice,
                  minMarks: r.marks[0],
                  maxMarks: r.marks[1],
                  prime: r.prime
                })
              }
            }
            //按商品（商品、主题、输入asin）
            else if(key === 'asin'){
              params.targetingParam.push({
                index:r.identity,
                asin:r.asin
              })
            }
          })
          SP.bidRecommendation(params).then(res => {
            this.form.items.forEach(i => {
              Object.assign(i,res.data.recommendations.find(r => i.identity === r.index)?.suggestedBid);
              i.recommendedBid = i.suggested;
            })
            this.$forceUpdate()
          });
        }
        this.refreshBtnDisable();
      },
      deleteAllItem() {
        this.form.items = [];
        this.refreshBtnDisable();
      },
      deleteItem(index) {
        this.form.items.splice(index, 1);
        this.refreshBtnDisable();
      },
      //商品-输入asin-点击添加前的校验
      async beforeFn() {
        // 不需要获取建议竞价
        if (!this.showSuggestedBidding) {
          return true;
        }
        // 需要获取建议竞价
        if (!this.formBase.campaignId) {
          this.$message.error("添加ASIN失败：请先选择广告活动")
          return false;
        }
        if (!this.formBase.groupId) {
          this.$message.error("添加ASIN失败：请先选择广告组")
          return false;
        }
        return true;
      },
      //商品-输入asin-点击添加的回调
      async afterFn(val) {
        // 不需要获取建议竞价
        // if (!this.showSuggestedBidding) {
        //   this.addAllItem(val.success.map(e => ({asin: e})),'asin', 'asin');
        //   return true;
        // }
        // 有广告组合id获取建议竞价

        // const expressions =  val.success.map(value => ([{type: "asinSameAs", value}]))
        // console.log(expressions)
        // let params = {
        //   marketId: this.marketId,
        //   targetingParam: {
        //     expressions:[[{type: "asinSameAs", value}]],
        //     adGroupId: this.formBase.groupId || null,
        //   },
        // }
        // try {
        //   let { data } = await getAdsSpProductTargetingSuggestedBid(params)
        //   let asins = []
        //   data.recommendations.forEach(e => {
        //     asins.push({
        //       type:"asin",
        //       asin: e.expression[0].value,
        //       rangeEnd: e.suggestedBid && e.suggestedBid.rangeEnd,
        //       rangeStart: e.suggestedBid && e.suggestedBid.rangeStart,
        //       recommendedBid: e.suggestedBid && e.suggestedBid.suggested,
        //     })
        //   })
          this.addAllItem(val.success.map(e => ({asin: e})),'asin', 'asin');
          // this.addAllItem( asins ,'asin', 'asin');
        // } finally {
        //   return true
        // }
      },
      starTo(marks) {
        if (isMeaningful(marks)) {
          return marks[0] + '-' + marks[1];
        } else {
          return '0-5';
        }
      },
      primeTo(prime) {
        if (prime === 'true') {
          return '具备Prime资格';
        } else {
          return '不具备Prime资格';
        }
      },
      formValidate() {
        return new Promise((resolve, reject) => {
          if (this.form.items.length <= 0) {
            this.$gjMessage.closeAll();
            this.$gjMessage.error('请添加商品投放');
            reject();
          } else {
            this.$refs.form.validate(valid => {
              valid ? resolve() : reject()
            });
          } 
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "picker";
  
  .gj-picker__editor {
    padding: 0;
  }
  .gj-picker,
  .gj-picker__editor {
    height: 445px;
  }
  .gj-picker__editor {
    height: 444px !important;
  }
  
  .default-bid {
    margin-bottom: 0;
    position: absolute;
    top: 0;
    left: 280px;
  }
  
  /deep/ .el-tabs__header {
    margin-bottom: 0 !important;
  }

  /deep/ .gj-picker__editor--search-input .el-input__inner {
    height: 46px;
    line-height: 46px;
    font-size: 14px;
  }

  /deep/ .gj-table td {
    padding: 5px 0 !important;
  }
  
  /deep/.vxe-table--body {
    .vxe-body--row {
      .vxe-body--column {
        height: 58px !important;
      }
    }
  }
</style>


